import React, { useMemo, useState } from "react";

import { useTranslation } from "react-i18next";

import { SvgSortBy } from "@routes/IconeSvg";

import DotLoader from "@components/tailwindComponents/DotLoader";
import EmptyData from "@components/tailwindComponents/EmptyData";
import { SORT_FUNCTION } from "@entreprise/employeTab/container/suivisDisciplinary/utils";

import DisciplinaryItemTable from "./DisciplinaryItemTable";

function DisciplinaryTable(props) {
  const { isLoading, disciplinaryList, readOnly, toggleModalDisciplinaryForm } =
    props;
  const { t: translator, i18n } = useTranslation("disciplinary.disciplinary");
  const [selectedSortType, setSelectedSortType] = useState("period_desc");
  const sortedDisciplinaryList = useMemo(
    () => [...disciplinaryList].sort(SORT_FUNCTION[selectedSortType]),
    [selectedSortType, disciplinaryList]
  );

  return (
    <div className="arh-mb-6 arh-font-poppins">
      <table className=" arh-w-full arh-table-fixed">
        <thead className="arh-bg-greyColor arh-font-semibold arh-text-darkColor">
          <tr className="arh arh-border arh-border-x-0 arh-border-b arh-border-t-0 arh-border-solid arh-border-greyBorderInput arh-px-5 arh-text-xs">
            <th className="arh-w-[18%] arh-px-5 arh-py-3 arh-text-xs">
              {translator("Titre de l'événement")}
            </th>
            <th className="arh-w-[12.5%] arh-px-5 arh-text-xs">
              {translator("Événement")}
            </th>
            <th className="arh-w-[12.5%] arh-px-5 arh-text-xs">
              {translator("Catégorie")}
            </th>
            <th className="arh-w-[12.5%] arh-px-5 arh-text-xs">
              {translator("Gradation")}
            </th>
            <th className="arh-w-[18%] arh-px-5 arh-text-xs">
              <div className="arh-flex arh-items-center">
                {translator("Date/Période")}
                <span
                  className="arh-ml-2 arh-cursor-pointer"
                  onClick={() => {
                    if (selectedSortType === "period_asc") {
                      setSelectedSortType("period_desc");
                    } else {
                      setSelectedSortType("period_asc");
                    }
                  }}
                >
                  {SvgSortBy()}
                </span>
              </div>
            </th>

            {/* Disparaisse en Myprofile */}
            {!readOnly ? (
              <>
                <th className="arh-w-[8.5%] arh-px-5 arh-text-xs">
                  {translator("Note interne")}
                </th>
                <th className="arh-w-[15%] arh-px-5 arh-text-xs">
                  {translator("Fichier")}
                </th>
                <th className="arh-w-[11%] arh-px-5 arh-text-xs">
                  {translator("Alerte")}
                </th>
                <th className="arh-w-[5%] arh-px-4 arh-py-3.5 arh-text-xs arh-font-semibold arh-capitalize arh-text-darkColor"></th>
              </>
            ) : (
              ""
            )}
          </tr>
        </thead>

        {/* Container table */}
        <tbody className="arh-font-medium arh-text-darkGreyColor">
          {isLoading ? (
            <tr>
              <td colSpan={!readOnly ? 9 : 5}>
                <div className="arh-h-[20dvh]">
                  <DotLoader size="small" />
                </div>
              </td>
            </tr>
          ) : sortedDisciplinaryList?.length > 0 ? (
            sortedDisciplinaryList.map((disciplinary) => (
              <React.Fragment key={disciplinary?._id}>
                <DisciplinaryItemTable
                  disciplinary={disciplinary}
                  translator={translator}
                  i18n={i18n}
                  readOnly={readOnly}
                  toggleModalDisciplinaryForm={toggleModalDisciplinaryForm}
                />
              </React.Fragment>
            ))
          ) : (
            <tr>
              <td
                colSpan={!readOnly ? 9 : 5}
                className="arh-w-full arh-pb-8 arh-pt-8"
              >
                <EmptyData>
                  {translator(
                    "Aucun suivi disciplinaire à afficher pour cet employé"
                  )}
                </EmptyData>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default DisciplinaryTable;
